import React from 'react';
import Productivity from './Productivity';
import Fuel from './Fuel';
import Spares from './Spares';
import Maintenance from './Maintenance';
import PredictiveMaintenance from './PredictiveMaintenance';

const Dashboard = ({ activeTab = 'Productivity', setActiveTab }) => {
  // Render the appropriate component based on activeTab
  if (activeTab === 'Fuel') {
    return <Fuel activeTab={activeTab} />;
  }

  if (activeTab === 'Spares') {
    return <Spares activeTab={activeTab} />;
  }

  if (activeTab === 'Maintenance') {
    return <Maintenance />;
  }

  if (activeTab === 'Predictive Maintenance') {
    return <PredictiveMaintenance activeTab={activeTab} />;
  }

  // Default to Productivity
  return <Productivity activeTab={activeTab} />;
};

export default Dashboard;
